import { styled } from '../../styled-components';

export const UiWithMarginSmall = styled.div.attrs({
  className: 'UiWithMarginSmall',
})`
  margin: ${p => p.theme.spaceSmall} 0;
`;
